import axios from "axios";
import { toast } from "react-toastify";
import { GET_WORKFLOW_DATA, SET_WORKFLOW_DATA ,GET_WORKFLOW_FILTER,GET_WORKFLOW_PROTOCOL} from "../../appConstants";



export const GetWorkflowData = async (id) => {
  
 
  
    const config = {
      method: "get",
      url: `${GET_WORKFLOW_DATA}?config_id=${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.access_token}`,
      },
    };
  
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };
  export const SetWorkflowData = async (data) => {
  

  
    const config = {
      method: "post",
      url: SET_WORKFLOW_DATA,
      headers: {
        Authorization: `Bearer ${localStorage.access_token}`,
      },
      data: data,
    };
  
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };
  export const GetWorkflowFilter = async (id) => {
  

  
    const config = {
      method: "get",
      url: `${GET_WORKFLOW_FILTER}?filter_id=${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.access_token}`,
      },
    };
  
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };
  export const GetWorkflowProtocol = async (id) => {
  

  
    const config = {
      method: "get",
      url: `${GET_WORKFLOW_PROTOCOL}?protocol_id=${id}`,
      headers: {
        Authorization: `Bearer ${localStorage.access_token}`,
      },
    };
  
    try {
      const response = await axios(config);
      return response.data;
    } catch (error) {
      toast.error(`Error: ${error.message}`, {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

